import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreateReTargetCustomerService=async(data)=>{
    try {
        const result = await publicPost(`api/admin/retarget_customer/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateReTargetCustomerService=async(data,id)=>{
    try {
        const result = await put(`api/admin/retarget_customer/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateReTargetFinalCheckCustomerService=async(data,id)=>{
    try {
        const result = await put(`api/admin/retarget_customer/update_final_check/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetReTargetCustomerService=async()=>{
    try {
        const result = await get(`api/admin/retarget_customer/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteReTargetCustomerService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/retarget_customer/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

